module.exports = __webpack_public_path__ + "img/DE00529.5d9a81d7.png";